'use client';

import { getFragmentData } from '@/__generated__';
import { ENTRY_BASE_FRAGMENT } from '@/gql/fragments/entries.gql';
import useScrollPosition from '@/lib/utils/useScrollPosition';
import { useTranslations } from 'next-intl';
import { useNavBar } from '../NavBar/useNavBar';
import { useNavbarActions } from '../NavBar/useNavbarState';
import Btn, { BtnProps } from '../ui/Btn';
import Txt from '../ui/Txt';
import * as styles from './NavDrawer.css';

export default function NavDrawerButton(props: BtnProps) {
  const { page } = useNavBar();
  const t = useTranslations('actions');
  const setNavPosition = useNavbarActions((s) => s.setNavPosition);

  const pos = useScrollPosition();

  const base = getFragmentData(ENTRY_BASE_FRAGMENT, page);
  const eventUri = base?.sectionHandle === 'event';

  return (
    <Btn
      variant="text"
      color={pos < 10 && eventUri ? 'white' : 'black'}
      fontFamily="heading"
      disableTransition
      onClick={() => setNavPosition(true)}
      StartIconProps={{ name: 'menu', className: styles.icon }}
      {...props}>
      <Txt uppercase style={{ marginBottom: '0.2rem' }}>
        {t('more')}
      </Txt>
    </Btn>
  );
}
